import React, { useState, useEffect, useRef } from "react"
import tw from "twin.macro"
import CompChartPrice from "./CompChartPrice"
import CompChartHeading from "./CompChartHeading"
import CompChartRow from "./CompChartRow"

const CompChart = (props) => {
    const [isSticky, setSticky] = useState(false)
    const ref = useRef(null)
    const handleScroll = () => {
        if (ref.current) {
            setSticky(ref.current.getBoundingClientRect().top <= 0)
        }
    }
    useEffect(() => {
        window.addEventListener("scroll", handleScroll)
        return () => {
            window.removeEventListener("scroll", () => handleScroll)
        }
    }, [])
    return (
        <section id="CompChart" css={tw`bg-grey-100 p-mobile md:p-tablet lg:p-desktop`}>
            <div
                css={tw`max-w-6xl mx-auto relative z-30 flex flex-wrap justify-center items-center lg:items-stretch flex-col lg:flex-row`}
            >
                <h3 css={tw`h2 mb-6 text-center w-full`}>
                    Comparez nos offres en détail
                </h3>{" "}
                <div
                    ref={ref}
                    css={tw`bg-grey-100 w-full m-auto flex top-0 `}
                    css={isSticky ? tw`sticky shadow-lg` : undefined}
                >
                    <div
                        css={tw`hidden lg:flex text-center lg:text-left w-full pt-4 lg:py-4 pl-8 lg:max-w-xl`}
                    >
                        <h3 
                            css={tw`h2 -mt-4 w-full self-center`}
                            css={isSticky ? tw`block` : tw`hidden`}>
                            Comparez nos offres <br />en détail
                        </h3>
                    </div>
                    <CompChartPrice
                        crown={props.crown}
                        datawa={`${props.datawa}_`}
                        name="Simple Start"
                        link="https://signup.quickbooks.intuit.com/?locale=fr-fr&offerType=buy&bc=OBI-LL3&offerId=20011852"
                        targetAudience="Idéal pour les indépendants et auto-entrepreneurs"
                        tooltip="Idéal pour les indépendants et auto-entrepreneurs"
                    />
                    <CompChartPrice
                        crown={props.crown}
                        datawa={`${props.datawa}_`}
                        name="Essentials"
                        link="https://signup.quickbooks.intuit.com/?locale=fr-fr&offerType=buy&bc=OBI-LL2&offerId=20022601"
                        targetAudience="Idéal pour les indépendants et TPE"
                        tooltip="Idéal pour les indépendants et TPE"
                    />
                    <CompChartPrice
                        crown={props.crown}
                        datawa={`${props.datawa}_`}
                        name="Plus"
                        link="https://signup.quickbooks.intuit.com/?locale=fr-fr&offerType=buy&bc=OBI-LL1&offerId=20022605"
                        targetAudience="Idéal pour les TPE et PME"
                        tooltip="Idéal pour les TPE et PME"                        
                    />
                </div>
                <div css={tw`bg-grey-100 w-full m-auto flex`}>
                    <div
                        css={tw`hidden lg:block text-center lg:text-left w-full pt-4 lg:py-4 pl-8 lg:max-w-xl`}
                    ></div>
                    <div
                        css={tw`mx-auto md:mt-5 md:ml-2`}
                        css={{ minWidth: "175px" }}
                    >
                        <p
                            css={tw`hidden lg:block text-center text-xs -mt-4 mb-6`}
                        >
                            Idéal pour les indépendants<br />
                            et auto-entrepreneurs
                        </p>
                    </div>
                    <div
                        css={tw`mx-auto md:mt-5`}
                        css={{ minWidth: "175px" }}
                    >
                        <p
                            css={tw`hidden lg:block text-center text-xs -mt-4 mb-6`}
                        >
                            Idéal pour les indépendants<br />
                            et TPE
                        </p>
                    </div>{" "}
                    <div
                        css={tw`mx-auto md:mt-5`}
                        css={{ minWidth: "175px" }}
                    >
                        <p
                            css={tw`hidden lg:block text-center text-xs -mt-4 mb-6`}
                        >
                            Idéal pour les TPE<br />
                            et PME
                        </p>
                    </div>{" "}
                </div>
                <div css={tw`w-full m-auto flex flex-col`}>
                    <ul
                        css={tw`p-0 list-none border-b border-l border-r border-solid border-grey-400 border-t-0`}
                    >
                        <CompChartHeading heading="Facturation et gestion commerciale" />
                        <CompChartRow
                            crown={props.crown}
                            text="Personnalisation des devis et factures : import de vos propres modèles ou choix parmi de nombreux modèles personnalisables"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Envois par email, suivi et gestion des devis, factures, avoirs, reçus de vente et reçus de remboursement"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Impayés et relances : alertes en cas de retard de paiement et envoi simplifié des relances"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Programmation de l’envoi des factures récurrentes"
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Refacturation des dépenses et des frais avancés pour vos clients, au réel ou avec marge"
                            pl
                        />
                        <CompChartHeading heading="Gestion des dépenses" />
                        <CompChartRow
                            crown={props.crown}
                            text="Gestion des dépenses par photo avec l'application mobile (iOS et Android)"
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Paiement des factures fournisseurs en un clic, avec notre partenaire Libeo"
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Gestion des bons de commande fournisseurs : création, envoi par email et suivi"
                            pl
                        />
                        <CompChartHeading heading="Trésorerie" />
                        <CompChartRow
                            crown={props.crown}
                            text="Suivi de trésorerie en temps réel grâce à la connexion sécurisée entre QuickBooks et votre banque (plus de 200 banques et néo-banques partenaires, françaises et internationales)"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Prévisionnel de trésorerie : obtenez une projection précise sur les prochains jours, semaines et mois"
                            es
                            pl
                        />
                        <CompChartHeading heading="Comptabilité" />
                        <CompChartRow
                            crown={props.crown}
                            text="Plan comptable français intégré et personnalisable"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Automatisation des rapprochements et de la saisie des écritures comptables"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Calcul automatisé de la TVA sur vos ventes"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Calcul automatisé de la TVA sur vos dépenses"
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Rapports comptables : compte de résultat, bilan provisoire, états financiers&hellip;"
                            es
                            pl
                        />

                        <CompChartHeading heading="Tableaux de bord et rapports" />
                        <CompChartRow
                            crown={props.crown}
                            text="Rapports de gestion commerciale : devis, factures, créances, paiements, avoirs, impayés, retards de paiements&hellip;"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Rapports de performance détaillés synchronisés et mis à jour en continu : dépenses, trésorerie, indicateurs financiers et comptables."
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Comptabilité analytique : suivi et analyses détaillées de la performance des activités, par client(s), produit(s), service(s), fournisseur(s), point(s) de vente&hellip;"
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Suivi budgétaire prévisionnel : création de projets et de business plans avec les objectifs à atteindre sur les prochaines semaines, mois et années"
                            pl
                        />
                        <CompChartHeading heading="Accès et nombre d'utilisateurs" />
                        <CompChartRow
                            crown={props.crown}
                            text="Accès gratuit pour l’expert-comptable"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Accès pour 1 utilisateur"
                            ss
                            es
                            pl
                        />
                        <CompChartRow text="Accès pour 3 utilisateurs" crown={props.crown} es pl />
                        <CompChartRow text="Accès pour 5 utilisateurs" crown={props.crown} pl />

                        <CompChartHeading heading="Services inclus" />
                        <CompChartRow
                            crown={props.crown}
                            text="Formation, aide au paramétrage et support client gratuit"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Certifié conforme aux exigences de l'administration fiscale"
                            ss
                            es
                            pl
                        />
                        <CompChartRow
                            crown={props.crown}
                            text="Sécurisation totale de l’accès et du stockage des données"
                            ss
                            es
                            pl
                        />
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default CompChart
